import {
  START_LOADING_INDICATOR,
  STOP_LOADING_INDICATOR,
} from "./loadingIndicatorTypes";

const initialState = {
  loading: false,
};

const loadingIndicatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING_INDICATOR:
      return {
        ...state,
        loading: true,
      };
    case STOP_LOADING_INDICATOR:
      return {
        ...state,
        loading: false,
      };
    default:
      return {
        ...state,
      };
  }
};

export default loadingIndicatorReducer;
